import React from 'react';
import UDIDropdownfield from "./UDIDropdownfield.js"


const GenericYesNo = ({
	UDI,
	setUDI,
	fieldTitle = "",
	fieldName = "",
	allowEmpty = false,
	mandatory = false,
	forceIsEditing = null
}) => {

	const LOV = [];

	if (allowEmpty)
		LOV.push({ key: "", value: "" });

	LOV.push({ key: "true", value: "Yes" });
	LOV.push({ key: "false", value: "No" });

	return <>
		<UDIDropdownfield UDI={UDI} setUDI={setUDI} fieldTitle={fieldTitle} fieldName={fieldName} LOV={LOV} mandatory={mandatory} forceIsEditing={forceIsEditing} />
	</>											  
}


export default GenericYesNo;


